import { jsxs, jsx } from 'react/jsx-runtime';

const SvgActionCopy = (props) => jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: [jsx("path", { fill: "#2D2E2E", d: "M2 22h16V6H2v16ZM4 8h12v12H4V8Z" }), jsx("path", { fill: "#2D2E2E", d: "M6 2v2h14v14h2V2H6Z" })] }));

export { SvgActionCopy as default };
//# sourceMappingURL=ActionCopy.es.js.map
